/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Err_Cannot_Disable_SelfInputs */

const en_adm_err_cannot_disable_self = /** @type {(inputs: Adm_Err_Cannot_Disable_SelfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You cannot disable your own account.`)
};

const de_adm_err_cannot_disable_self = /** @type {(inputs: Adm_Err_Cannot_Disable_SelfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kannst dein eigenes Konto nicht deaktivieren.`)
};

/**
* | output |
* | --- |
* | "You cannot disable your own account." |
*
* @param {Adm_Err_Cannot_Disable_SelfInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_err_cannot_disable_self = /** @type {((inputs?: Adm_Err_Cannot_Disable_SelfInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Err_Cannot_Disable_SelfInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_err_cannot_disable_self(inputs)
	return en_adm_err_cannot_disable_self(inputs)
});